import React from 'react';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

interface CountryDelegationsProps {
    country: string;
    cities: string[];
    flag: string;
}

const CountryDelegations: React.FC<CountryDelegationsProps> = ({ country, cities, flag }) => (
    <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
            <span className="mr-3 text-2xl">{flag}</span>
            {country}
        </h3>
        <ul className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            {cities.map(city => (
                <li key={city} className="text-base text-gray-700">{city}</li>
            ))}
        </ul>
    </div>
);


export const DelegationsModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
    const delegations = [
        { country: 'Sede Central', cities: ['Andorra la Vella'], flag: '🇦🇩' },
        { country: 'España', cities: ['Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Bilbao', 'Zaragoza'], flag: '🇪🇸' },
        { country: 'Francia', cities: ['París', 'Marsella', 'Lyon', 'Niza', 'Toulouse'], flag: '🇫🇷' },
        { country: 'Italia', cities: ['Roma', 'Milán', 'Nápoles', 'Turín'], flag: '🇮🇹' },
        { country: 'Portugal', cities: ['Lisboa', 'Oporto', 'Faro'], flag: '🇵🇹' },
        { country: 'Alemania', cities: ['Berlín', 'Múnich', 'Frankfurt', 'Hamburgo'], flag: '🇩🇪' }
    ];

    return (
        <ModalBase isOpen={isOpen} onClose={onClose} title="Nuestras Delegaciones">
            <div className="text-center mb-10">
                <h3 className="text-3xl font-bold text-gray-800">Presencia local con alcance europeo</h3>
                <p className="mt-3 text-lg text-gray-600">
                    Contamos con una amplia red de delegaciones y colaboradores para ofrecerte un servicio cercano y eficaz en toda Europa.
                </p>
            </div>
            <div className="space-y-6">
                {delegations.map(d => (
                    <CountryDelegations key={d.country} {...d} />
                ))}
            </div>
             <p className="mt-10 text-center text-sm text-gray-500">
                Aunque no veas tu ciudad en la lista, operamos en todo el territorio de estos países. ¡Contáctanos!
            </p>
        </ModalBase>
    );
};
